var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"booking-details"},[_vm._m(0),_c('accommodation',{attrs:{"products":_vm.filterProducts('Storage')}}),_c('booking-pitches')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h2',{staticClass:"my-3"},[_vm._v("Details van de stalling")])])])
}]

export { render, staticRenderFns }